export enum Route {
    Home = "Home",
    ContactingFirstAiders = "Contacting First Aiders",
}